import { render } from "./UpdateProgress.vue?vue&type=template&id=0bdce48a&scoped=true"
import script from "./UpdateProgress.vue?vue&type=script&lang=js"
export * from "./UpdateProgress.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdce48a"]])

export default __exports__